export function heroSlider() {
    let $parentSection = $(".hero-section-wrap");
    let $slides = $(".hero-slide");
    let $heroBg = $(".hero-bg-item");
    let $progresItems = $(".hero-progress > .hero-progress-item");
    let $win = $(window);
    let height = 100;
    let $body = $("body");

    let appendVideo = function () {
        for (let i = 0; i < $heroBg.length; i++) {

            if ($($heroBg[i]).attr("data-hero-video-src")) {
                let video = $("<video class='hero-video' preload='metadata' autoplay playsinline muted><source src='" + $($heroBg[i]).attr("data-hero-video-src") + "' type='video/mp4'></video>");
                $($heroBg[i]).append(video);
            }
        }
    };

    let toggleContent = function (index, isChangeBg, bgIndex) {
        $slides.removeClass("visible");
        $heroBg.removeClass("visible");
        $progresItems.removeClass("active");
        $($slides[index]).addClass("visible");
        $($progresItems[bgIndex]).addClass("active");


        if (isChangeBg) {
            $($heroBg[bgIndex]).addClass("visible");
        }
    };

    if ($body.hasClass("home-page") && document.cookie.indexOf("showPreloader=") < 0) {
        $body.addClass("show-preloader");

        let expiry = new Date();
        expiry.setTime(expiry.getTime() * 10);
        document.cookie = "showPreloader=yes; path=/; expires=" + expiry.toGMTString();

        setTimeout(() => {
            $body.removeClass("show-preloader");
        }, 5500);
    }

    for (let i = 0; i < $slides.length; i++) {

        // if (i > 0) {
        height += 100;
        // }
    }

    $parentSection.css({
        "height": height + "vh"
    });

    if ($win.scrollTop() >= 0 && $win.scrollTop() < $win.height()) {
        $($slides[0]).addClass("visible");
    } else {
        $parentSection.addClass("show-gradient");
    }

    $win.on("scroll", function () {
        if ($win.scrollTop() >= 0 && $win.scrollTop() < $win.height()) {
            toggleContent(0, true, 0);
            $parentSection.removeClass("show-gradient");
        } else if ($win.scrollTop() >= $win.height() && $win.scrollTop() < $win.height() * 2) {
            $parentSection.addClass("show-gradient");
            toggleContent(1, true, 0);
        } else if ($win.scrollTop() >= $win.height() * 2 && $win.scrollTop() < $win.height() * 3) {
            toggleContent(2, true, 1);
        } else if ($win.scrollTop() >= $win.height() * 3 && $win.scrollTop() < $win.height() * 4) {
            toggleContent(3, true, 2);
        }
    });

    appendVideo();
};


// WEBPACK FOOTER //
// ./assets/js/modules/heroSlider.js